import { AppPermissionState } from 'api/browser/fetchPermissionStatus'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { useAppRestrictionsWithoutGeolocationAbTest } from './useAppRestrictionsWithoutGeolocationAbTest'

export const useShowUserLocationAbTest = () => {
  const { permissionState, authorized } = useShallowEqualSelector(
    ({
      geolocation: { permissionState },
      authorizationReducer: { authorized },
    }) => ({
      permissionState,
      authorized,
    })
  )

  const restriction = useAppRestrictionsWithoutGeolocationAbTest()

  const isShow = () => {
    if (!authorized) {
      return true
    }

    if (!restriction?.mediumRestriction && !restriction?.maximumRestriction) {
      return true
    }

    switch (permissionState) {
      case null:
      case AppPermissionState.Prompt:
      case AppPermissionState.Denied:
        return false
      case AppPermissionState.Granted:
        return true
    }
  }

  return {
    showUserLocation: isShow(),
  }
}
